import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AuthService } from '../../services/auth.service';
import { CustomValidators } from 'src/app/shared/utilities/custom-validators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: UntypedFormGroup;
  code: string = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly fb: UntypedFormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly toastService: ToastService
  ) {
    this.resetPasswordForm = this.fb.group({
      password: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true
          }),
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          CustomValidators.patternValidator(
            /[!*@#$%^&+=]/,
            { hasSpecialCharacters: true }
          ),
          Validators.minLength(6)
        ])
      ],
      passwordConfirm: [null, [Validators.required, this.passwordMatchValidator.bind(this)]],
    });
  }

  passwordMatchValidator(control: AbstractControl) {
    if (!this.resetPasswordForm) return null;

    return control.value === this.resetPasswordForm.get('password')?.value ? null : { passwordMismatch: true };
  }

  ngOnInit(): void {
    this.code = this.route.snapshot.paramMap.get('id') || '';
  }

  get field(): { [key: string]: AbstractControl; } {
    return this.resetPasswordForm.controls;
  }

  setPassword(): void {
    if (this.isValid()) {
      this.authService.recover(this.resetPasswordForm.value, this.code).subscribe(
        () => {
          this.toastService.toast('Senha alterada com sucesso.', EMessageType.Success);
          this.router.navigate(['login']);
        },
        (res) => {
          this.toastService.toast(res.error.errors[0], EMessageType.Error);
        }
      );
    }
  }

  private isValid(): boolean {
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      this.toastService.toast('Os campos são Obrigatórios', EMessageType.Error);
      return false;
    }

    const resetPasswordValue = this.resetPasswordForm.value;

    if (resetPasswordValue.password !== resetPasswordValue.passwordConfirm) {
      this.toastService.toast('Confirmar a senha deve ser igual a senha', EMessageType.Error);
      return false;
    }

    if (this.code === '') {
      this.toastService.toast('Código inválido, por favor clique no link do e-mail novamente', EMessageType.Error);
      return false;
    }

    return true;
  }
}
